import Vue from 'vue'
import Clickoutside from './clickoutside'
import NoThrough from './no-through'

Vue.directive('clickoutside', Clickoutside)
Vue.directive('no-through', NoThrough)
